import { z } from 'zod';

import { shiftSchema } from './Shift.ts';

export const vehicleSchema = z.object({
  id: z.number(),
  provider: z.string(),
  display_identifier: z.string(),
  shuttle_provider_identifier: z.string(),
  dispatch_provider_identifier: z.string(),
  latitude: z.number().nullable(),
  longitude: z.number().nullable(),
  current_node: z.number().nullable(),
  next_node: z.number().nullable(),
  charge_percentage: z.union([z.string(), z.number()]),
  is_charging: z.boolean(),
  door_status: z.string(),
  robot_mode: z.string(),
  supervision_mode: z.string(),
  automata_state: z.string(),
  is_online: z.boolean(),
  updated_at: z.string(),
  shift: shiftSchema.optional().nullable(),
  can_arrive_by_itself: z.boolean(),
});

export const vehiclePatchSchema = z.object({
  automata_state: z.string().optional(),
  display_identifier: z.string().optional(),
  can_arrive_by_itself: z.boolean().optional(),
});

export const createMissionSchema = z.object({
  dispatch_destination_node_id: z.number(),
  activity: z.number(),
});

export type CreateMission = z.infer<typeof createMissionSchema>;
export type IVehicle = z.infer<typeof vehicleSchema>;
